import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';

const ThreeDSecureCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>(
    'processing'
  );
  const [message, setMessage] = useState<string>('');

  useEffect(() => {
    const handleThreeDSecureResult = async () => {
      try {
        // URLパラメータから結果を取得
        const urlParams = new URLSearchParams(location.search);
        const tokenId = urlParams.get('token_id');
        const status = urlParams.get('status');

        if (!tokenId) {
          throw new Error('トークンIDが見つかりません');
        }

        if (status === 'succeeded') {
          // 3-Dセキュア認証成功
          setStatus('success');
          setMessage('3-Dセキュア認証が完了しました。');

          // 少し待ってから予約プレビューページに戻る
          setTimeout(() => {
            navigate('/reserve-preview', {
              state: {
                threeDSecureToken: tokenId,
                threeDSecureSuccess: true,
              },
            });
          }, 2000);
        } else {
          throw new Error('3-Dセキュア認証に失敗しました');
        }
      } catch (error) {
        console.error('3-Dセキュア処理エラー:', error);
        setStatus('error');
        setMessage(
          error instanceof Error
            ? error.message
            : '認証処理中にエラーが発生しました'
        );

        // エラーの場合は予約ページに戻る
        setTimeout(() => {
          navigate('/reserve');
        }, 3000);
      }
    };

    handleThreeDSecureResult();
  }, [location, navigate]);

  return (
    <div className="page-layout">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <Card className="shadow-sm">
              <Card.Header>
                <h2 className="mb-0">決済認証処理</h2>
              </Card.Header>
              <Card.Body className="text-center py-5">
                {status === 'processing' && (
                  <>
                    <Spinner
                      animation="border"
                      className="mb-3"
                      style={{ width: '3rem', height: '3rem' }}
                    />
                    <h4>認証結果を処理中...</h4>
                    <p className="text-muted">しばらくお待ちください</p>
                  </>
                )}

                {status === 'success' && (
                  <>
                    <div className="text-success mb-3">
                      <i
                        className="fas fa-check-circle"
                        style={{ fontSize: '4rem' }}
                      ></i>
                    </div>
                    <h4 className="text-success">認証完了</h4>
                    <p>{message}</p>
                    <p className="text-muted">自動的に決済画面に戻ります...</p>
                  </>
                )}

                {status === 'error' && (
                  <>
                    <div className="text-danger mb-3">
                      <i
                        className="fas fa-exclamation-circle"
                        style={{ fontSize: '4rem' }}
                      ></i>
                    </div>
                    <h4 className="text-danger">認証失敗</h4>
                    <Alert variant="danger">{message}</Alert>
                    <p className="text-muted">予約ページに戻ります...</p>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ThreeDSecureCallback;
